<template>
	<div class="media">
		<EntryTableEditor
			ref="view"
			:contentTypeId="contentTypeId"
		/>
	</div>
</template>

<script>
import EntryTableEditor from '../components/EntryTableEditor.vue'
import ProviderMixin from './ProviderMixin.js'

export default {
	name: 'ContentTableEdit',
	components: { EntryTableEditor },
	mixins: [ ProviderMixin ],
	inject: [ 'base' ],
	computed: {
		contentTypeId() {
			if (!this.$route.path.includes('/content_type/')) return null
			return this.$route.params.id || null
		},
	},
	methods: {
		// stackingview needs this to work..
		/*
		routerBeforeEach(to, from, next) {
			this.$refs.view.routerBeforeEach(to, from, next)
		},
		*/
	},
}
</script>
